export const UTILITIES_PATHS = {
  COLOR: '/utilities/color'
} as const
